import { Css, Tooltip, useTestIds } from "@homebound/beam";

type PackageVersionStatusProps = { version: string; hasUpdates: boolean };

/** A package's version with a dot that is yellow when the package has pending updates and green otherwise. */
export function PackageVersionStatus(props: PackageVersionStatusProps) {
  const { version, hasUpdates } = props;
  const tid = useTestIds(props, "packageVersionStatus");
  return (
    <div css={Css.df.aic.gapPx(6).$}>
      <Tooltip title={hasUpdates ? "Pending updates" : "Up to date"} {...tid}>
        <div css={Css.wPx(8).hPx(8).fs0.br100.if(hasUpdates).bgYellow500.else.bgGreen400.$} />
      </Tooltip>
      <span css={Css.gray700.$}>{version}</span>
    </div>
  );
}
